export default __webpack_public_path__ + "static/media/type-twice-pinnately-compound-leaf.5ed2062c.PNG";